module.exports = __webpack_public_path__ + "img/smart-thumbs.86a7b056.svg";